import { render, staticRenderFns } from "./StudentInformationTimeline.vue?vue&type=template&id=a98905e6&scoped=true&lang=pug&"
import script from "./StudentInformationTimeline.vue?vue&type=script&lang=ts&"
export * from "./StudentInformationTimeline.vue?vue&type=script&lang=ts&"
import style0 from "./StudentInformationTimeline.vue?vue&type=style&index=0&id=a98905e6&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a98905e6",
  null
  
)

export default component.exports